[
  {
    "name": "About",
    "href": "/about",
    "dropdownSkidding": -10,
    "children": [
      { "name": "About Us", "href": "/about" },
      { "name": "Team", "href": "/about#team" }
    ]
  },
  {
    "name": "Courses",
    "href": "/courses",
    "dropdownSkidding": 10,
    "children": [
      { "name": "가을학기 정규반", "href": "/courses/fall" },
      { "name": "2026 여름/가을 대회 트랙", "href": "/courses/competitions-2026" },
      { "name": "초등부 대회", "href": "/courses/competitions-jr" },
      { "name": "중·고등부 대회", "href": "/courses/competitions-sr" }
    ]
  },
  {
    "name": "Competitions",
    "href": "/competitions",
    "dropdownSkidding": -60,
    "children": [
      { "name": "2026 여름/가을 대회", "href": "/competitions/2026" },
      { "name": "초등부 대회", "href": "/competitions/jr" },
      { "name": "중·고등부 대회", "href": "/competitions/sr" }
    ]
  },
  { "name": "Capstone", "href": "/capstone" },
  { "name": "Sprint", "href": "/sprint" },
  { "name": "Personal Projects", "href": "/personalprojects" }
]
